import { render, staticRenderFns } from "./BindsList.vue?vue&type=template&id=69774aca&scoped=true"
import script from "./BindsList.vue?vue&type=script&lang=js"
export * from "./BindsList.vue?vue&type=script&lang=js"
import style0 from "./BindsList.vue?vue&type=style&index=0&id=69774aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69774aca",
  null
  
)

export default component.exports